import React, { useState, useEffect, useContext, useMemo } from "react";
import { fDMA } from "../../../utils/fecha";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Col,
  Badge,
} from "reactstrap";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import CurrencyInput from "react-currency-input-field";

function ListadoAnticiposProveedores() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ANTICIPOS = process.env.REACT_APP_URL_ANTICIPOS;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_ABONOS_PROVEEDORES = process.env.REACT_APP_URL_ABONOS_PROVEEDORES;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  let hace90dias = moment(date).subtract(90, "days").format("YYYY-MM-DD");

  const [anticipos, setAnticipos] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState("");
  // C17: filtro por importe — "todos" / "conImporte" (>0) / "cero" (=0)
  const [selectedImporte, setSelectedImporte] = useState("conImporte");
  // C18: filtro por saldo — default sólo los que tienen saldo pendiente
  const [selectedSaldo, setSelectedSaldo] = useState("conSaldo");
  const [activo, setActivo] = useState(""); // "" | "Si" | "No"

  const [modalAplicar, setModalAplicar] = useState(false);
  const toggleAplicar = () => setModalAplicar(!modalAplicar);

  const [idAnticipoEdit, setIdAnticipoEdit] = useState("");
  const [saldoAnticipo, setSaldoAnticipo] = useState(0);
  const [tcAnticipo, setTcAnticipo] = useState(1);
  const [proveedorAnticipo, setProveedorAnticipo] = useState("");
  const [proveedorAnticipoNombre, setProveedorAnticipoNombre] = useState("");
  const [numeroAnticipo, setNumeroAnticipo] = useState("");
  const [notasPendientes, setNotasPendientes] = useState([]);
  const [totalAplicado, setTotalAplicado] = useState(0);

  useEffect(() => {
    cargarAnticipos();
  }, []);

  function cargarAnticipos() {
    axios
      .get(URL_ANTICIPOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const rows = (res.data || [])
          .filter((a) => a.tipo === "Proveedor")
          .map((a) => ({
            _id: a._id,
            numero: a.idAnticipo,
            fecha: a.fecha,
            proveedor: a.proveedores?.[0]?.nombre_comercial || "",
            idProveedor: a.proveedores?.[0]?._id || "",
            oc: a.ordenesCompra?.[0]
              ? `OC #${a.ordenesCompra[0].idOrdenCompra}`
              : "",
            importe: Number(a.importe || 0),
            utilizado: Number(a.utilizado || 0),
            saldo: Number(a.saldo || 0),
            tipoCambio: a.tipoCambio,
            formaPago: a.formaPago,
            estado: a.is_active === "Si" ? "Activo" : "Cancelado",
            activo: a.is_active,
          }))
          .sort((a, b) => (a.numero < b.numero ? 1 : -1));
        setAnticipos(rows);
      })
      .catch((err) => console.log(err));
  }

  function aplicarAnticipo(row) {
    setIdAnticipoEdit(row._id);
    setSaldoAnticipo(row.saldo);
    setTcAnticipo(Number(row.tipoCambio) || 1);
    setProveedorAnticipo(row.idProveedor);
    setProveedorAnticipoNombre(row.proveedor);
    setNumeroAnticipo(row.numero);
    setTotalAplicado(0);

    axios
      .get(`${URL_NOTAS_CXP}Proveedor/${row.idProveedor}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const pendientes = (res.data || [])
          .filter((n) => Number(n.saldo) > 0 && n.is_active === "Si")
          .map((n) => ({
            id: n._id,
            fecha: n.fecha,
            embarque:
              n.embarques && n.embarques.length > 0
                ? `Emb #${n.embarques[0].idEmbarques}`
                : `Nota #${n.idNotasCxP}`,
            contenedor: n.embarques?.[0]?.contenedor || "",
            total_costo: Number(n.total_costo || 0),
            saldo: Number((n.saldo || 0).toFixed(2)),
            importe: 0,
            completa: false,
            observaciones: "NA",
          }))
          .sort((a, b) => (a.fecha > b.fecha ? 1 : -1));
        setNotasPendientes(pendientes);
        toggleAplicar();
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudieron cargar las notas del proveedor",
        });
      });
  }

  const handleChangeImporte = (value, name, id) => {
    const next = notasPendientes.map((i) => {
      if (i.id !== id) return i;
      const importeNum = parseFloat(value) || 0;
      if (importeNum > i.saldo) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El importe excede el saldo de la nota",
        });
        return i;
      }
      return { ...i, importe: value, completa: false };
    });
    setNotasPendientes(next);
    const suma = next.reduce(
      (acc, r) => acc + (parseFloat(r.importe) || 0),
      0
    );
    setTotalAplicado(suma);
  };

  // Palomita: pasa todo el saldo de la nota al importe (topado al saldo
  // disponible del anticipo, contando lo ya capturado en otras notas).
  const toggleNotaCompleta = (id, checked) => {
    let next;
    if (!checked) {
      next = notasPendientes.map((i) =>
        i.id === id ? { ...i, importe: 0, completa: false } : i
      );
    } else {
      const usadoOtras = notasPendientes.reduce(
        (acc, r) => acc + (r.id === id ? 0 : parseFloat(r.importe) || 0),
        0
      );
      const disponible = Math.max(0, Number((saldoAnticipo - usadoOtras).toFixed(2)));
      const nota = notasPendientes.find((i) => i.id === id);
      const monto = Math.min(Number(nota?.saldo || 0), disponible);
      if (monto <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Sin saldo disponible",
          text: "El anticipo ya no tiene saldo disponible para aplicar",
        });
        return;
      }
      next = notasPendientes.map((i) =>
        i.id === id ? { ...i, importe: monto, completa: true } : i
      );
    }
    setNotasPendientes(next);
    const suma = next.reduce(
      (acc, r) => acc + (parseFloat(r.importe) || 0),
      0
    );
    setTotalAplicado(suma);
  };

  const handleChangeObs = (id, value) => {
    setNotasPendientes(
      notasPendientes.map((i) =>
        i.id === id ? { ...i, observaciones: value } : i
      )
    );
  };

  function savePagoAnticipo() {
    if (totalAplicado <= 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes capturar al menos un importe",
      });
      return;
    }
    if (totalAplicado > saldoAnticipo) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El total aplicado excede el saldo del anticipo",
      });
      return;
    }

    Swal.fire({
      title: "Estas seguro?",
      text: "Se aplicará el anticipo a las notas seleccionadas",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Aplicar!",
    }).then((result) => {
      if (!result.isConfirmed) return;

      const filas = notasPendientes.filter(
        (a) => Number(a.importe) > 0
      );
      let pendientes = filas.length;
      if (pendientes === 0) return;

      filas.forEach((a) => {
        axios
          .post(
            URL_ABONOS_PROVEEDORES,
            {
              fecha: hoy,
              importe: parseFloat(a.importe),
              proveedores: proveedorAnticipo,
              concepto: `Anticipo #${numeroAnticipo} Aplicado`,
              tipoCambio: tcAnticipo,
              bancos: undefined,
              notasCxP: a.id,
              anticipos: idAnticipoEdit,
              observaciones: a.observaciones,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            pendientes -= 1;
            if (pendientes === 0) {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Aplicar Anticipo Proveedor",
                  detalle: `Anticipo #${numeroAnticipo} aplicado por ${totalAplicado}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire(
                "Good job!",
                "Anticipo aplicado correctamente",
                "success"
              );
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Hubo un error al aplicar el anticipo",
            });
          });
      });
    });
  }

  function cancelarAnticipo(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelará el anticipo",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (!result.isConfirmed) return;
      axios
        .get(`${URL_ANTICIPOS}Cancel/${id}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then(() => {
          Swal.fire("Cancelado", "Anticipo cancelado", "success");
          cargarAnticipos();
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo cancelar",
          });
        });
    });
  }

  const filtered = useMemo(() => {
    const q = (search || "").toLowerCase();
    return anticipos.filter((a) => {
      if (selectedFechaInicio && a.fecha < selectedFechaInicio) return false;
      if (selectedFechaFin && a.fecha > selectedFechaFin) return false;
      if (activo && a.activo !== activo) return false;
      // C17: filtro por importe
      if (selectedImporte === "conImporte" && !(Number(a.importe || 0) > 0)) return false;
      if (selectedImporte === "cero" && Number(a.importe || 0) !== 0) return false;
      // C18: filtro por saldo
      if (selectedSaldo === "conSaldo" && !(Number(a.saldo || 0) > 0)) return false;
      if (selectedSaldo === "sinSaldo" && Number(a.saldo || 0) > 0) return false;
      if (!q) return true;
      return (
        (a.proveedor || "").toLowerCase().includes(q) ||
        String(a.numero).includes(q) ||
        (a.oc || "").toLowerCase().includes(q)
      );
    });
  }, [anticipos, search, selectedFechaInicio, selectedFechaFin, activo, selectedImporte, selectedSaldo]);

  const moneyUSD = (v) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(v || 0));

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pagoProveedores ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/AnticiposProveedoresCreate"
                className="btn btn-success"
              >
                Nuevo Anticipo
              </Button>
              <Button
                size="sm"
                href="/MenuCXP"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col md={4}>
              <Input
                type="text"
                placeholder="Buscar por proveedor, número u OC"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Col>
          </Row>
          <h3 align="center">Anticipos a Proveedores</h3>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                onChange={(e) => setSelectedFechaInicio(e.target.value)}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                onChange={(e) => setSelectedFechaFin(e.target.value)}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Estado</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                onChange={(e) => setActivo(e.target.value)}
              >
                <option value="">Todos</option>
                <option value="Si">Activos</option>
                <option value="No">Cancelados</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Importe</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedImporte}
                onChange={(e) => setSelectedImporte(e.target.value)}
              >
                <option value="conImporte">Con importe</option>
                <option value="todos">Todos</option>
                <option value="cero">Solo en 0</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Saldo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedSaldo}
                onChange={(e) => setSelectedSaldo(e.target.value)}
              >
                <option value="conSaldo">Con saldo</option>
                <option value="todos">Todos</option>
                <option value="sinSaldo">Sin saldo</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table striped borderless>
            <thead>
              <tr>
                <th>Numero</th>
                <th>Fecha</th>
                <th>Proveedor</th>
                <th>OC</th>
                <th>TC</th>
                <th>Importe</th>
                <th>Utilizado</th>
                <th>Saldo</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((a) => (
                <tr key={a._id}>
                  <td>{a.numero}</td>
                  <td>{fDMA(a.fecha)}</td>
                  <td>{a.proveedor}</td>
                  <td>{a.oc}</td>
                  <td>{a.tipoCambio}</td>
                  <td>{moneyUSD(a.importe)}</td>
                  <td>{moneyUSD(a.utilizado)}</td>
                  <td>
                    <Badge color={a.saldo > 0 ? "warning" : "secondary"}>
                      {moneyUSD(a.saldo)}
                    </Badge>
                  </td>
                  <td>
                    <Badge color={a.activo === "Si" ? "success" : "danger"}>
                      {a.estado}
                    </Badge>
                  </td>
                  <td>
                    {a.activo === "Si" ? (
                      <>
                        <Button
                          color="info"
                          size="sm"
                          disabled={a.saldo <= 0}
                          onClick={() => aplicarAnticipo(a)}
                        >
                          Aplicar
                        </Button>{" "}
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => cancelarAnticipo(a._id)}
                        >
                          <i class="fas fa-ban"></i>
                        </Button>
                      </>
                    ) : (
                      <span className="text-muted">—</span>
                    )}
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr>
                  <td colSpan="10" align="center">
                    Sin anticipos
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      ) : undefined}

      <Modal size="xl" isOpen={modalAplicar} toggle={toggleAplicar}>
        <ModalHeader toggle={toggleAplicar}>
          <h4>
            Aplicar Anticipo #{numeroAnticipo} — {proveedorAnticipoNombre}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>Saldo del Anticipo</Label>
              <Input value={moneyUSD(saldoAnticipo)} disabled />
            </Col>
            <Col md={3}>
              <Label>Total a Aplicar</Label>
              <Input value={moneyUSD(totalAplicado)} disabled />
            </Col>
            <Col md={3}>
              <Label>Saldo Restante del Anticipo</Label>
              <Input value={moneyUSD(saldoAnticipo - totalAplicado)} disabled />
            </Col>
          </Row>
          <br />
          <Table striped borderless>
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Nota / Embarque</th>
                <th>Contenedor</th>
                <th>Total</th>
                <th>Saldo</th>
                <th align="center">✓</th>
                <th>Importe</th>
                <th>Observaciones</th>
              </tr>
            </thead>
            <tbody>
              {notasPendientes.map((a) => (
                <tr key={a.id}>
                  <td>{fDMA(a.fecha)}</td>
                  <td>{a.embarque}</td>
                  <td>{a.contenedor}</td>
                  <td>{moneyUSD(a.total_costo)}</td>
                  <td>{moneyUSD(a.saldo)}</td>
                  <td align="center" style={{ verticalAlign: "middle" }}>
                    <Input
                      type="checkbox"
                      checked={a.completa || false}
                      onChange={(e) => toggleNotaCompleta(a.id, e.target.checked)}
                      style={{ position: "static", marginLeft: 0 }}
                    />
                  </td>
                  <td>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      name="importe"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={a.importe}
                      className={`form-control`}
                      onValueChange={(value, name) =>
                        handleChangeImporte(value, name, a.id)
                      }
                    />
                  </td>
                  <td>
                    <Input
                      type="text"
                      value={a.observaciones}
                      onChange={(e) => handleChangeObs(a.id, e.target.value)}
                    />
                  </td>
                </tr>
              ))}
              {notasPendientes.length === 0 && (
                <tr>
                  <td colSpan="8" align="center">
                    No hay notas pendientes
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={savePagoAnticipo}>
            Aplicar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoAnticiposProveedores;
